var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ri:send-plane-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.94632 9.31602C1.42432 9.14102 1.42032 8.86002 1.95732 8.68102L21.0433 2.32002C21.5723 2.14402 21.8753 2.44002 21.7273 2.95802L16.2743 22.044C16.1233 22.573 15.8183 22.591 15.5943 22.089L12.0003 14L18.0003 6.00002L10.0003 12L1.94632 9.31602Z",
    fill: "#787878"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.7b44879b25e1feab5a9cd9b858b7eaf3.svg";
export { ForwardRef as ReactComponent };